__turbopack_context__.v({
  "className": "poppins_957f66ac-module__-jnpPG__className",
});
